// extracted by mini-css-extract-plugin
module.exports = {"headline":"az_xhb","image":"az_yhb","description":"az_zhb"};